<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="注册时间"
                        prop="registerrange">
            <el-date-picker
              v-model="search.registerrange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              :default-time="['00:00:00', '23:59:59']"
              class="width-max">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户状态"
                        prop="status">
            <el-select v-model="search.status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户当前状态"
                        prop="currentstatus">
            <el-select v-model="search.currentstatus"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in otherOptions.currentstatus"
                :key="item.id"
                :label="item.keyword"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户等级"
                        prop="level">
            <el-select v-model="search.level"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.level"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型"
                        prop="type">
            <el-select v-model="search.type"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.type"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行卡验证"
                        prop="bankcardverified">
            <el-select v-model="search.bankcardverified"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.bankcardverified"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份验证"
                        prop="idnumverified">
            <el-select v-model="search.idnumverified"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.idnumverified"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人手机"
                        prop="referrer">
            <el-input placeholder="请输入名称"
                      v-model="search.referrer"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="推荐码"
                        prop="referrercode">
            <el-input placeholder="请输入名称"
                      v-model="search.referrercode"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="mobile">
            <el-input placeholder="请输入名称"
                      v-model="search.mobile"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="身份证号"
                        prop="idnum">
            <el-input placeholder="请输入名称"
                      v-model="search.idnum"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="设备号"
                        prop="devicenum">
            <el-input placeholder="请输入名称"
                      v-model="search.devicenum"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="标签名"
                        prop="tagids">
            <remote-select
              multiple
              class="width-max"
              clearable
              id-key="id"
              keyword-key="keyword"
              label-key="tagname"
              value-key="id"
              placeholder="请输入关键词"
              v-model="search.tagids"
              :query-request="getUserNormalTagTable"
              :find-request="getUserTagDetail">
            </remote-select>

          </el-form-item>
          <el-form-item label="排除标签"
                        prop="not_tagids">
            <remote-select
              multiple
              collapse-tags
              class="width-max"
              clearable
              id-key="id"
              keyword-key="keyword"
              label-key="tagname"
              value-key="id"
              placeholder="请输入关键词"
              v-model="search.not_tagids"
              :query-request="getUserTagTable"
              :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="标签组名"
                        prop="taggroupids">
            <remote-select
              multiple
              class="width-max"
              clearable
              id-key="id"
              keyword-key="keyword"
              label-key="tagname"
              value-key="id"
              placeholder="请输入关键词"
              v-model="search.taggroupids"
              :query-request="getUserGroupTagTable"
              :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="工种"
                        prop="work_type">
            <el-select v-model="search.work_type"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in workTypeMap"
                :key="item.id"
                :label="item.title"
                :value="item.id">
                <template v-if="item.disabled">
                  <span style="float: left;color: #9ba0a5;">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}
                  </span>
                </template>
                <template v-else>
                  <span style="float: left;">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                </template>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="厂家"
                        prop="belongto">
            <el-input placeholder="请输入名称"
                      v-model="search.belongto"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="厂家关联"
                        prop="referrer_belongto">
            <el-input placeholder="请输入名称"
                      v-model="search.referrer_belongto"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="自选职业"
                        prop="occupation">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              label-key="name"
              value-key="id"
              placeholder="请选择职业"
              v-model="search.occupation_id"
              :query-request="getOccupationTable"
              :find-request="getOccupationDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="注册平台"
                        prop="register_app_type">
            <el-select v-model="search.register_app_type"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option v-for="item in options.register_app_type"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最后登录时间"
                        prop="last_active_tp">
            <el-date-picker v-model="search.last_active_tp"
                            style="width: 100%;"
                            clearable
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="职业信息状态"
                        prop="workinfo_status">
            <el-select v-model="search.workinfo_status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option v-for="item in options.workinfoStatus"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="累计做单金额"
                        prop="cumulative_bounty">
            <el-input style="width: 45%;"
                      placeholder="最小金额(元)"
                      clearable
                      v-model="search.cumulative_bounty[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="最大金额(元)"
                      clearable
                      v-model="search.cumulative_bounty[1]"/>
          </el-form-item>
          <el-form-item label="身份证省市区"
                        prop="idcard_regionids">
            <el-cascader
              v-model="search.idcard_regionids"
              class="width-max"
              :options="chinaAreaData"
              :props="{ checkStrictly: true }"
              filterable
              clearable >
            </el-cascader>
          </el-form-item>
        </div>

        <div class="re-el-form__flex">
          <el-form-item label="关键字"
                        prop="keyword">
            <el-input placeholder="请输入名称"
                      v-model="search.keyword"
                      clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/users/form'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
        <router-link :to="'/user-batch-tag/add/form'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量添加标签
          </el-button>
        </router-link>
        <router-link :to="'/user-batch-tag/delete/form'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量删除标签
          </el-button>
        </router-link>
      </div>
      <el-table ref="table"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="userid"
                         label="用户id"
                         width="100px"></el-table-column>
        <el-table-column prop="cellphone"
                         label="手机号"
                         width="110px">
          <template slot-scope="scope">
            <router-link style="text-decoration:none"
                         @click.native="rememberDetailUser(scope.row.userid)"
                         :to="'/users/detail/info?userid='+scope.row.userid">
              <span style="color:rgb(88,157,248);">{{scope.row.cellphone}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="用户名称"
                         width="80px"></el-table-column>
        <el-table-column label="所在地"
                         width="150px">
          <template slot-scope="scope">
            <span>{{scope.row.provincename}}&nbsp;&nbsp;{{scope.row.cityname}}&nbsp;&nbsp;{{scope.row.areaname}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="所在卖场"></el-table-column>
        <el-table-column prop="str_register_app_type"
                         label="注册平台"
                         width="90px"></el-table-column>
        <el-table-column prop="registertime"
                         label="注册时间"></el-table-column>
        <el-table-column prop="status"
                         label="用户状态">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === parseInt(scope.row.status)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentstatus"
                         label="用户当前状态">
          <template slot-scope="scope">
            <span v-for="item in otherOptions.currentstatus"
                  v-if="item.id === parseInt(scope.row.currentstatus)">{{item.keyword}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumverified"
                         label="身份验证状态">
          <template slot-scope="scope">
            <span v-for="item in options.idnumverified"
                  v-if="item.value === parseInt(scope.row.idnumverified)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="wx_account"
                         label="微信账号"></el-table-column>
        <el-table-column prop="workinfo_status"
                         label="职业信息状态">
          <template slot-scope="scope">
            <span v-for="item in options.workinfoStatus"
                  v-if="parseInt(item.value) === parseInt(scope.row.workinfo_status)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="latest_communicate_record"
                         label="最后沟通详情"></el-table-column>
        <el-table-column prop="memo"
                         label="备注"></el-table-column>
        <el-table-column label="操作"
                         width="160px">
          <template slot-scope="scope">
            <router-link :to="{ path: '/order/table?userid='+scope.row.userid}">
              <el-button size="mini"
                         class="margin b5">订单列表
              </el-button>
            </router-link>
            <router-link :to="{ path: '/users/update/'+scope.row.userid}">
              <el-button type="primary"
                         size="mini"
                         class="margin b5">修改
              </el-button>
            </router-link>
            <router-link :to="{ path: '/users/freeze/form/'+scope.row.userid}"
                         v-if="parseInt(scope.row.status) === 1">
              <el-button type="danger"
                         size="mini"
                         class="margin b5">封号
              </el-button>
            </router-link>
            <el-button type="success"
                       size="mini"
                       v-if="[-1, -2].includes(parseInt(scope.row.status))"
                       @click="onUnFreezeUser(scope.row.userid)">解封
            </el-button>
            <el-dropdown>
              <el-button size="mini"
                         type="primary">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link :to="{ path: '/point/deduct/form/'+scope.row.userid}">
                    零豆扣除
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ path: '/point/add/form/'+scope.row.userid}">
                    零豆添加
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="parseInt(scope.row.status) === 1">
                  <router-link :to="{ path: '/user-credit/update/'+scope.row.userid}"
                               v-if="parseInt(scope.row.status) === 1">
                    赏金操作
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a href="javascript:" @click="onDeboundWx(scope.row.userid)">解绑微信</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a href="javascript:" @click="modifyUserPhone(scope.row.userid)">更换手机号</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary"
                       size="mini"
                       @click="onUpdateWorkInfo(scope.row.userid)">编辑零工职业信息
            </el-button>
            <br>
            <el-button type="primary"
                       style="margin-top: 5px;"
                       size="mini"
                       @click="onAddUserCommRecord(scope.row.userid)">添加用户沟通记录
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <UpdateWorkInfo ref="updateWorkInfo" @submitted="closeWorkInfoDialog"/>

    <UserCommunicateForm title="新增用户沟通记录"
                         :record_obj="recordObj"
                         :lockUserId="disableUserId"
                         @closeAndRefresh="closeUserCommDialog()"
                         :visible="userCommVisible">
    </UserCommunicateForm>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'

import UpdateWorkInfo from '../components/UpdateWorkInfoDialog.vue'
import UserCommunicateForm from '../components/UserCommunicateForm'
import { NumberArray } from '@utils/common'

const LAST_DETAIL_USER_ID_KEY = 'users.table.lastDetailUserId'

export default {
  components: {
    UpdateWorkInfo, UserCommunicateForm
  },
  mixins: [table],
  data () {
    return {
      userOptions: {
        tags: [],
        taggroups: [],
      },
      loading: false,
      recordObj: {},
      disableUserId: false,
      userCommVisible: false,
      search: {
        registerrange: [],
        status: 1,
        currentstatus: null,
        level: null,
        believable: null,
        type: null,
        bankcardverified: null,
        idnumverified: null,
        referrer: null,
        referrercode: null,
        mobile: null,
        idnum: null,
        devicenum: null,
        tagids: [],
        taggroupids: [],
        keyword: null,
        work_type: null,
        belongto: null,
        referrer_belongto: null,
        occupation_id: null,
        not_tagids: [],
        last_active_tp: [],
        register_app_type: null,
        workinfo_status: null,
        cumulative_bounty: [null, null],
        idcard_regionids: [],
      },
      // 搜索字段申明
      searchFieldType: {
        status: Number,
        currentstatus: Number,
        level: Number,
        believable: Number,
        type: Number,
        bankcardverified: Number,
        idnumverified: Number,
        mobile: Number,
        tagids: Array,
        not_tagids: Array,
        work_type: Number,
        register_app_type: Number,
        occupation_id: Number,
        workinfo_status: Number,
        cumulative_bounty: Array,
        idcard_regionids: NumberArray,
      },
      exportHeader: [
        { key: 'userid', text: '用户ID' },
        { key: 'realname', text: '真实姓名' },
        { key: 'provincename', text: '省份' },
        { key: 'cityname', text: '城市' },
        { key: 'areaname', text: '地区' },
        { key: 'id_card_province_name', text: '身份证省份' },
        { key: 'id_card_city_name', text: '身份证城市' },
        { key: 'id_card_area_name', text: '身份证地区' },
        { key: 'id_card_sex', text: '身份证性别' },
        { key: 'id_card_age', text: '身份证年龄' },
        { key: 'idcard_address', text: '身份证地址' },
        { key: 'idcard_expired_date', text: '身份证失效日期' },
        { key: 'idcard_expire_status_str', text: '身份证有效状态' },
        { key: 'cellphone', text: '手机号码' },
        { key: 'strstatus', text: '用户状态' },
        { key: 'strcurrentstatus', text: '用户当前状态' },
        { key: 'referrer', text: '推荐人手机' },
        { key: 'registertime', text: '注册时间' },
        { key: 'str_register_app_type', text: '注册平台' },
        { key: 'cumulative_bounty', text: '累计赏金' },
        { key: 'balance', text: '账户余额' },
        { key: 'salary_last_update_time', text: '赏金最后更新时间' },
        { key: 'customername', text: '最后任务所属客户' },
        { key: 'tag_info', text: '主平台标签（显示名称）' },
        { key: 'clientmodel', text: '手机型号' },
        { key: 'devicenum', text: '手机设备号' },
        { key: 'clientversion', text: 'APP版本号' },
        { key: 'strlevel', text: '用户等级' },
        { key: 'str_is_super', text: '是否为超级零工' },
        { key: 'str_super', text: '超级零工属性' },
        { key: 'str_ability_group', text: '用户能力组' },
        { key: 'business_type', text: '行业' },
        { key: 'work_type', text: '工种' },
        { key: 'belongto', text: '公司名称' },
        { key: 'main_brand', text: '主营品牌' },
        { key: 'workcard_photo', text: '上传工作证明' },
        { key: 'workinfo_status_cn', text: '职业信息状态' },
        { key: 'referrer_belongto', text: '厂家关联' },
        { key: 'wx_account', text: '微信账号' },
        { key: 'occupation_text', text: '自选职业' },
        { key: 'know_from', text: '了解渠道' },
        { key: 'last_active_tp', text: '最后登录时间' },
        { key: 'str_last_active_app_type', text: '最后登录平台' },
      ],
      isLoadTableInBeforeRouteEnter: false,
      chinaAreaData: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.users.options,
      users: state => state.login.user,
      otherOptions: state => state.users.userOptions,
    }),
    workTypeMap () {
      const businessWorkType = _.cloneDeep(this.otherOptions.business_work_type)
      const newWorkTypes = []
      if (_.isArray(businessWorkType)) {
        const businessWorkTypeIds = businessWorkType.map(item => item.id)
        // 排序一下，未禁用的放到前面去
        const sortedData = businessWorkType.sort((a, b) => {
          return (a.disabled ? 1 : 0) - (b.disabled ? 1 : 0)
        })
        for (const item of sortedData) {
          const businessType = this.otherOptions.business_type.find(it => it.id === item.businessTypeId)
          if (_.get(businessType, 'title', false)) {
            item.title = `${businessType.title} - ${item.title}`
          }
          if (_.get(item, 'disabled', false)) {
            item.title = item.title + '(已弃用)'
          }
          newWorkTypes.push(item)
        }
        // 从 this.otherOptions.work_type 完整列表中,捞取已被废弃的旧版本
        for (const item of this.otherOptions.work_type) {
          if (!businessWorkTypeIds.includes(item.id)) {
            newWorkTypes.push({
              id: item.id,
              title: item.keyword + '(已弃用)',
              desc: '已弃用',
              disabled: true
            })
          }
        }
      }
      return newWorkTypes
    },
  },
  created () {
    this.$store.dispatch('getUserRelatedOptions')
    this.getChinaAreaData()
  },
  mounted () {
    this.initSearchAndLoadTable()
  },
  methods: {
    ...request.map([
      'getOccupationTable',
      'getOccupationDetail',
      'getUserTagTable',
      'getUserTagDetail',
      'getUserGroupTagTable',
      'getUserNormalTagTable',
    ]),
    /**
     * 拉取全部排他标签 id（与后端 MapSearch::getExclusiveTags 一致，数据源为 query_tag + exclusive=1）
     */
    async fetchAllExclusiveTagIds () {
      const perPage = 500
      let page = 1
      const ids = []
      while (true) {
        const res = await this.getUserTagTable({
          exclusive: 1,
          per_page: perPage,
          current_page: page,
        })
        const payload = res.data
        const rows = payload.data || []
        rows.forEach(row => ids.push(String(row.id)))
        const total = Number(payload.total) || 0
        if (rows.length < perPage || page * perPage >= total) break
        page += 1
      }
      return ids
    },
    /**
     * 首次进入：合并路由参数；未带 not_tagids 时默认排除全部排他标签，再加载列表
     */
    async initSearchAndLoadTable () {
      let exclusiveIds = []
      try {
        exclusiveIds = await this.fetchAllExclusiveTagIds()
      } catch (e) {
        this.$message.error('加载排他标签失败，排除标签将保持为空')
      }
      const queryParams = this.getRouterQueryParams(this.$route.query, this.$route.params)
      const merged = _.merge({}, this.$options.data.call(this).search, queryParams)
      if (!Object.prototype.hasOwnProperty.call(queryParams, 'not_tagids')) {
        merged.not_tagids = exclusiveIds
      }
      this.setSearchParams(merged)
      this.loadTableData(queryParams)
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getUserList', params).then(res => {
        for (let m = 0; m < res.data.data.length; m++) {
          res.data.data[m].workinfo_status = res.data.data[m].workinfo_status || 0
        }
        return res
      })
    },
    setTableData ({data}) {
      this.$set(this, 'table', data.data)
      this.setPagination(data)
      this.$nextTick(this.scrollToLastDetailUser)
    },
    rememberDetailUser (userid) {
      if (userid === undefined || userid === null) {
        return
      }
      try {
        window.sessionStorage.setItem(LAST_DETAIL_USER_ID_KEY, String(userid))
      } catch (e) {}
    },
    consumeLastDetailUserId () {
      let userid = null
      try {
        userid = window.sessionStorage.getItem(LAST_DETAIL_USER_ID_KEY)
        window.sessionStorage.removeItem(LAST_DETAIL_USER_ID_KEY)
      } catch (e) {}
      return userid
    },
    scrollToLastDetailUser () {
      const userid = this.consumeLastDetailUserId()
      if (!userid) {
        return
      }
      const rowIndex = this.table.findIndex(item => String(item.userid) === String(userid))
      if (rowIndex === -1) {
        return
      }
      const row = this.table[rowIndex]
      const tableRef = this.$refs.table
      if (tableRef && typeof tableRef.setCurrentRow === 'function') {
        tableRef.setCurrentRow(row)
      }
      this.scrollTableRowIntoView(rowIndex)
    },
    scrollTableRowIntoView (rowIndex) {
      const tableRef = this.$refs.table
      const tableEl = tableRef && tableRef.$el
      const rows = tableEl ? tableEl.querySelectorAll('.el-table__body-wrapper tbody tr') : []
      const rowEl = rows[rowIndex]
      if (!rowEl || typeof rowEl.scrollIntoView !== 'function') {
        return
      }
      rowEl.scrollIntoView({behavior: 'smooth', block: 'center'})
    },
    onExportSearch () {
      let self = this
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('exportUser', params),
        requestParams: this.search,
        getResponseData (data) {
          for (let m = 0; m < data.data.length; m++) {
            data.data[m].cumulative_bounty = parseFloat(data.data[m].balance) + parseFloat(data.data[m].frozenbalance) + parseFloat(data.data[m].totalwithdraw)
            if (!data.data[m].customername) {
              data.data[m].customername = ''
            }

            if (data.data[m].id_card_age === false) {
              data.data[m].id_card_age = ''
            }

            if (data.data[m].id_card_sex === false) {
              data.data[m].id_card_sex = ''
            } else if (data.data[m].id_card_sex === 0) {
              data.data[m].id_card_sex = '男'
            } else if (data.data[m].id_card_sex === 1) {
              data.data[m].id_card_sex = '女'
            }

            for (let i = 0; i < self.options.status.length; i++) {
              if (parseInt(data.data[m].status) === self.options.status[i].value) {
                data.data[m].strstatus = self.options.status[i].label
              }
            }

            for (let i = 0; i < self.options.currentstatus.length; i++) {
              if (parseInt(data.data[m].currentstatus) === self.options.currentstatus[i].value) {
                data.data[m].strcurrentstatus = self.options.currentstatus[i].label
              }
            }

            for (let i = 0; i < self.options.level.length; i++) {
              if (parseInt(data.data[m].level) === self.options.level[i].value) {
                data.data[m].strlevel = self.options.level[i].label
              }
            }

            if (data.data[m].str_super_attr) {
              const superAttr = data.data[m].str_super_attr
              data.data[m].str_super = Array.isArray(superAttr)
                ? superAttr.join(',')
                : String(superAttr)
            }
            if (data.data[m].ability_group) {
              const ag = data.data[m].ability_group
              data.data[m].str_ability_group = Array.isArray(ag) ? ag.join(',') : String(ag)
            }
            data.data[m].str_is_super = data.data[m].is_super === 1 ? '是' : '不是'

            if (data.data[m].work_type && data.data[m].work_type !== '0') {
              for (let i = 0; i < self.otherOptions.work_type.length; i++) {
                if (parseInt(data.data[m].work_type) === self.otherOptions.work_type[i].id) {
                  data.data[m].work_type = self.otherOptions.work_type[i].keyword
                }
              }
            } else {
              data.data[m].work_type = ''
            }

            const businessTypeObj = self.otherOptions.business_type.find(it => it.id + '' === _.get(data.data[m], 'business_type') + '')
            data.data[m].business_type = _.get(businessTypeObj, 'title', '')

            if (Array.isArray(data.data[m].workcard_photo)) {
              data.data[m].workcard_photo = data.data[m].workcard_photo.join(';')
            }
            const workInfoStatus = data.data[m].workinfo_status || 0
            for (let i = 0; i < self.options.workinfoStatus.length; i++) {
              if (parseInt(workInfoStatus) === self.options.workinfoStatus[i].value) {
                data.data[m].workinfo_status = self.options.workinfoStatus[i].label
                break
              }
            }
          }
          return data
        },
      })
    },
    onUnFreezeUser (id) {
      request.common('unFreezeUser', id).then(({data}) => {
        this.$message.success('解封成功')
        setTimeout(() => { this.onRefresh() }, 2000)
      })
    },
    onUpdateWorkInfo (id) {
      this.$refs.updateWorkInfo.open(id)
    },
    onAddUserCommRecord (id) {
      this.recordObj = {userid: id}
      this.disableUserId = true
      this.userCommVisible = true
    },
    closeUserCommDialog () {
      this.recordObj = {}
      this.disableUserId = false
      this.userCommVisible = false
      this.onRefresh()
    },
    closeWorkInfoDialog () {
      setTimeout(() => { this.onRefresh() }, 2000)
    },
    modifyUserPhone (id) {
      this.$prompt('您正在更换用户手机号，请确保与用户充分沟通后操作此功能', '更换用户手机号', {
        inputPattern: /\S+/,
        inputErrorMessage: '请输入新手机号码',
        inputPlaceholder: '请输入新手机号码',
      }).then(({value}) => {
        request.common('updateUserPhone', {id, cellphone: value}).then(({data}) => {
          this.$message.success('更换用户手机号成功')
          setTimeout(() => { this.onRefresh() }, 2000)
        })
      }).catch(() => {
        this.$message.info('已取消更换用户手机号操作')
      })
    },
    onDeboundWx (id) {
      this.$confirm('请确保已与零工沟通确认解绑零工微信。', '解绑微信', {type: 'warning'}).then(() => {
        request.common('unBoundUserWeixin', {id}).then(({data}) => {
          this.$message.success('微信解绑成功')
        })
      })
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/users/pages/UsersTable.vue